import React from 'react'
import classNames from 'classnames'

import Arrow from '../../icons/Arrow'

import './button.css'

const Button = (props) => {
  const { className, children, disabled, onClick = () => {} } = props
  const buttonClasses = classNames('xpa-button', {
    'xpa-button--disabled': disabled
  }, className)

  return (
    <button
      onClick={onClick}
      className={buttonClasses}
    >
      {children}
    </button>
  )
}

Button.Arrow = (props) => {
  const { onClick, disabled = false, left, styles = {}, className } = props
  const classes = classNames('xpa-button__arrow', {
    'xpa-button__arrow--disabled': disabled,
    'xpa-button__arrow--left': left,
  }, className)

  return (
    <button onClick={onClick} className={classes} style={styles} disabled={disabled}>
      <Arrow height={45} width={40} />
    </button>
  )
}

export default Button
